import { ofType } from 'redux-observable';
import { switchMap, mergeMap } from 'rxjs/operators';

import {
    fetchWithdrawalBalanceV2 as fetchWithdrawalBalanceV2Action,
    fetchWithdrawalBalanceV2Success,
    fetchWithdrawalBalanceV2Error,
} from '@perpay-web/fintech/actions/entities/withdrawalBalance';
import {
    fetchWithdrawalBalance as fetchWithdrawalBalanceAction,
    createWithdrawalRequest as createWithdrawalRequestAction,
    createWithdrawalRequestErrors,
    createWithdrawalRequestSuccess,
    replaceWithdrawalBalance,
    withdrawalBalanceError,
} from '@perpay-web/fintech/actions/ui/withdrawal';
import {
    WITHDRAWAL_BALANCE_ENDPOINT,
    WITHDRAWAL_CREATE_ENDPOINT,
} from '@perpay-web/fintech/constants/urls';
import { handleErrorMessageWithFallback } from '@perpay-web/observable/operators/handleErrorMessageWithFallback';
import { emitOrTimeout } from '@perpay-web/utils/observable';

const fetchWithdrawalBalance = (action$, state$, { get }) =>
    action$.pipe(
        ofType(fetchWithdrawalBalanceAction().type),
        switchMap(() => emitOrTimeout(get(WITHDRAWAL_BALANCE_ENDPOINT))),
        mergeMap((results) => [replaceWithdrawalBalance(results.response)]),
        handleErrorMessageWithFallback((error) => [
            withdrawalBalanceError(error),
        ]),
    );

const fetchWithdrawalBalanceV2 = (action$, state$, { get }) =>
    action$.pipe(
        ofType(fetchWithdrawalBalanceV2Action().type),
        switchMap(() => emitOrTimeout(get(WITHDRAWAL_BALANCE_ENDPOINT))),
        mergeMap((results) => [
            fetchWithdrawalBalanceV2Success(results.response),
        ]),
        handleErrorMessageWithFallback((error) => [
            fetchWithdrawalBalanceV2Error(error),
        ]),
    );

const createWithdrawalRequest = (action$, state$, { post }) =>
    action$.pipe(
        ofType(createWithdrawalRequestAction().type),
        switchMap((action) => {
            const { payload } = action;
            const accountUuid = payload;
            const requestBody = {
                to_account_uuid: accountUuid,
            };
            return emitOrTimeout(post(WITHDRAWAL_CREATE_ENDPOINT, requestBody));
        }),

        mergeMap((results) => [createWithdrawalRequestSuccess(results)]),
        handleErrorMessageWithFallback((error) => [
            createWithdrawalRequestErrors(error),
        ]),
    );

export {
    createWithdrawalRequest,
    fetchWithdrawalBalance,
    fetchWithdrawalBalanceV2,
};
